/**
 * Cross-cutting display formatters.
 *
 * These are used by every analytics card and the recent-calls table. Living
 * in one file lets every consumer pick exactly the helpers it needs and
 * keeps formatting consistent across the dashboard (and any future page).
 */

/** Format an integer with locale-aware thousands separators. */
export const formatInt = (n) => (n ?? 0).toLocaleString();

/**
 * Format a duration in seconds as a compact human string.
 *
 * Examples:
 *   42  → "42s"
 *   90  → "1m 30s"
 *   240 → "4m"
 *   3700 → "1h 1m"
 */
export const formatDurationSeconds = (s) => {
  if (!Number.isFinite(s)) return "—";
  if (s < 60) return `${Math.round(s)}s`;
  const m = Math.floor(s / 60);
  const rem = Math.round(s % 60);
  if (m < 60) return rem === 0 ? `${m}m` : `${m}m ${rem}s`;
  const h = Math.floor(m / 60);
  const mr = m % 60;
  return mr === 0 ? `${h}h` : `${h}h ${mr}m`;
};

/** Short, locale-aware "Jun 17, 14:32" style timestamp. */
export const formatDateTime = (iso) => {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
